import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ac40ecb4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ac40ecb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac40ecb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac40ecb4')) {
      api.createRecord('ac40ecb4', component.options)
    } else {
      api.reload('ac40ecb4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ac40ecb4&scoped=true&", function () {
      api.rerender('ac40ecb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/userComment/index.vue"
export default component.exports